import { Form, SubmitButton, TextInputField } from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { IndicatorMeasurementFormSchema } from '../../models';

type FormValues = z.infer<typeof IndicatorMeasurementFormSchema>;

type Props = {
  initialValues?: FormValues;
  isEdit?: boolean;
  onSubmit: (data: FormValues) => void;
};

export const IndicatorMeasurementForm: FC<Props> = ({
  initialValues,
  isEdit,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(IndicatorMeasurementFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextInputField
        required
        name="name"
        autocompleteKey="indicatorMeasurement.name"
        label={t('name')}
        control={control}
        errors={errors}
      />

      <SubmitButton disabled={!isDirty && isEdit} />
    </Form>
  );
};
